export default {
  DIAGNOSTIC_CAMERA_TIMELINE (state, value) {
    state.cameraTimeline = value
  },
  DIAGNOSTIC_CLIENT_DATA (state, value) {
    state.clientData = value
  }
}
